import httpRequestPromise, { METHODS } from 'app/httpRequestPromise';
import {KINOKASSA_API_URL} from 'app/constants/SettingsConstants';
import { setPromoIsFetching, getPromoItemSuccess, getPromosFail, getPromosSuccess } from 'app/modules/promo/redux/promoActions';
import { IPromoItem, IPromoItemDetails } from 'app/modules/promo/promoTypes';

export const getPromosRequest = (cinemaId: number | string | null, cityId: number) => async dispatch => {
	dispatch(setPromoIsFetching());

	const query = cinemaId ? `cinema_id=${cinemaId}` : `city_id=${cityId}`;

	try {
		const promos = await httpRequestPromise<IPromoItem[]>(
			`${KINOKASSA_API_URL}/api/v2/promo?${query}`,
			METHODS.GET
		);

		dispatch(getPromosSuccess(promos));
	} catch (error) {
		dispatch(getPromosFail(error));
	}
};

export const getPromoItemRequest = (promoId: string) => async dispatch => {
	dispatch(setPromoIsFetching());

	try {
		const response = await httpRequestPromise<IPromoItemDetails>(
			`${KINOKASSA_API_URL}/api/v2/promo/${promoId}`,
			METHODS.GET
		);

		dispatch(getPromoItemSuccess(response));
	} catch (error) {
		dispatch(getPromosFail(error));
	}
};
